import { aggregationFields, analystAggregation } from "../direct/aggregationFields";

const DEFAULT_AGG_SIZE = 7;

export const getAggregations = () => ({
  ...analystAggregation,
  ...aggregationFields.reduce((acc, field) => {
    acc[field] = {
      terms: { field, size: getAggSize(field) },
    };
    return acc;
  }, {}),
});

const getAggSize = (field) => aggSizes[field] || DEFAULT_AGG_SIZE;

const aggSizes = {
  "gicsSectors.en": 11,
  "gicsSectors.ja": 11,
  "periodicals.en": 5,
  "periodicals.ja": 5,
  "companies.en": 5,
  "companies.ja": 5,
  "themes.en": 10,
  "themes.ja": 10,
  "tradeIdeas.en": 5,
  "tradeIdeas.ja": 5,
  "regions.en": 5,
  "regions.ja": 5,
  "countries.en": 5,
  "countries.ja": 5,
  "currencies.en": 5,
  "currencies.ja": 5,
};
